import ContentLoader from "react-content-loader";

const MediaModalLoader = (props) => (
  <ContentLoader
    rtl
    speed={10}
    width={"100%"}
    height={500}
    viewBox="0 0 100 100"
    backgroundColor="#f6f5f4"
    foregroundColor="#deddda"
    {...props}
  >
    <rect x="0" y="0" rx="0" ry="0" width="500" height="500" />
  </ContentLoader>
);

export default MediaModalLoader;
